"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _DropdownItem = _interopRequireDefault(require("../DropdownItem"));

var GroupedItemList = function GroupedItemList(_ref) {
  var groupName = _ref.groupName,
      items = _ref.items;
  return (0, _preact.h)("div", {
    className: "control-dropdown__list--grouped dropdown__list--group-name_".concat(groupName.toLowerCase().split(' ').join('-'))
  }, (0, _preact.h)("div", {
    className: "control-dropdown__list--group-name"
  }, groupName), items.map(function (item) {
    return (0, _preact.h)(_DropdownItem.default, {
      title: item.title,
      key: item.value,
      onClick: item.onClick,
      value: item.value,
      image: item.image
    });
  }));
};

var _default = GroupedItemList;
exports.default = _default;